<template>

  <div class="h-100">
    <div v-if="false" class="loading_page" style=" padding: 10px; z-index: 9000000">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <cam-stream-container />

    <map-table  
          :meta="devicesMeta"
          :data="device_table_data" 
          :request-status="d_requestStatus" 
          :perPageOptions="perPageOptions" 
          :title="$t('Devices List')"
          :is-table-sidebar-active.sync="isDevicesTableSideBarActive" 
          :total-rows="totalDevices" 
          with-action 
          :selected-item.sync="selected_device"
          :table-columns="devicesTableColumns" 
          :table-object.sync="refDeviceListTable" 
          :search-query-filter.sync="searchQuery" 
          :selected-device.sync="selected_device"
          :per-page-filter.sync="perPage" 
          :tracked_devices.sync="tracked_devices" 
          :current-page-filter.sync="currentPage"
      >

      <template v-slot:filter>
          <devices-list-filters 
              :owners-options="ownersOptions" 
              :contracts-options="contractsOptions"
              :categories-options="categoriesOptions" 
              :types-options="typesOptions" 
              :groups-options="groupsOptions"
              :type-filter.sync="typeFilter" 
              :categories-filter.sync="categoriesFilter"
              :owners-filter.sync="ownersFilter" 
              :contracts-filter.sync="contractsFilter" 
              :group-filter.sync="groupFilter"
            >
          </devices-list-filters>
      </template>

      <template v-slot:colors-map>

          <b-col cols="12">
            <ul class="status-list">

              <li class="status-item">
                <span class="dot d-offline"></span>
                <span class="dot-txt">{{$t("offLine")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-idle"></span>
                <span class="dot-txt">{{$t("idle")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-moving"></span>
                <span class="dot-txt">{{$t("moving")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-stop"></span>
                <span class="dot-txt">{{$t("stop")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-overspeed"></span>
                <span class="dot-txt">{{$t("OverSpeed")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-ignitionoff"></span>
                <span class="dot-txt">{{$t("ignitionOff")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-pto"></span>
                <span class="dot-txt">{{$t("pto")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-sweep"></span>
                <span class="dot-txt">{{$t("sweep")}}</span>
              </li>

              <li class="status-item">
                <span class="dot d-unknown"></span>
                <span class="dot-txt">{{$t("unknown")}}</span>
              </li>
            </ul>
          </b-col>

      </template>

      <template v-slot:getRoute>
        <d-route :device="selected_device" @fetchedPoints="fetchedPoints" @clearRoute="clearRoute" @sendRequest="sendRequest" ></d-route>
      </template>

    </map-table>
    <map-table
            :meta="devicesMeta" 
            :data="geofence_table_data" 
            :request-status="g_requestStatus" 
            :perPageOptions="perPageOptions" 
            :title="$t('Geofence List')"
            :is-table-sidebar-active.sync="isGeofenceTableSideBarActive" 
            :total-rows="totalGeofence"
            :table-columns="geofenceTableColumns" 
            :table-object.sync="refGeofenceListTable" 
            :search-query-filter.sync="gSearchQuery"
            :per-page-filter.sync="gPerPage" 
            :current-page-filter.sync="gCurrentPage" 
            :selected-row.sync="selected_geofence"
          >

          <template v-slot:filter>
              <geofence-list-filters  
                  :categories-filter.sync="gCategoriesFilter" 
                  :owners-filter.sync="gOwnersFilter"
                  :contracts-filter.sync="gContractsFilter" 
                  :group-filter.sync="gGroupFilter"
                  :category-options="gCategoriesOptions" 
                  :contract-options="gContractsOptions" 
                  :group-options="gGroupsOptions"
                  :devices-options="gDevicesOptions" 
                  :device-filter.sync="gDeviceFilter" 
                  :owners-options="gOwnersOptions"
                  :type-options="gTypesOptions"
                >
              </geofence-list-filters>
          </template>

        </map-table>

    <div :class="'tables-options'">
      <div class="tab-click">
          <div class="icon-wrapper" v-b-tooltip.hover.left="'dashboard'" v-on:click="resetDirection(),$router.push('/')">
            <img width="20px" :src="require('@/assets/icons/home.png')" alt="">
          </div>

          <div class="icon-wrapper" :class="{'option-active':isDevicesTableSideBarActive }"
              v-b-tooltip.hover.left="'devices'"
              @click="isDevicesTableSideBarActive = !isDevicesTableSideBarActive; isGeofenceTableSideBarActive = false">
            <img width="20px" :src="require('@/assets/icons/truck.png')" alt="">
          </div>

          <div class="icon-wrapper" :class="{'option-active':isGeofenceTableSideBarActive }"
              v-b-tooltip.hover.left="'geofences'"
              @click="isGeofenceTableSideBarActive = !isGeofenceTableSideBarActive; isDevicesTableSideBarActive = false">
            <img width="20px" :src="require('@/assets/icons/map.png')" alt="">
          </div>

          <div class="icon-wrapper"
              :class="{'option-active':!allMarkersVisibility }"
              v-b-tooltip.hover.left="'show/hide marker'"
              @click="toggleMarkersVisibility">
            <img width="20px" :src="require('@/assets/icons/location-marker.png')" alt="">
          </div>

          <div class="icon-wrapper"
              :class="{'option-active':!geofenceVisibility }"
              v-b-tooltip.hover.left="$t('show/hide geofence')" @click="toggleGeofence">
            <img width="20px" :src="require('@/assets/icons/coverage.png')" alt="">
          </div>

          <div class="icon-wrapper"
              :class="{'option-active':makeReport }"
              v-b-tooltip.hover.left="$t('make report')" @click="makeReport = !makeReport">
            <img width="20px" :src="require('@/assets/icons/flag_report.png')" alt="">
          </div>

        </div>
  </div>

  <div dir="ltr">
    <l-map ref="mapRef" style="height: 100%; width: 100%"
            :zoom="zoom" :center="center">
      <l-tile-layer :url="url"></l-tile-layer>
    </l-map>
  </div>

  </div>

</template>

<script>

import { LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet"
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'
import { VBToggle, VBTooltip } from 'bootstrap-vue'
import MapTable from '@/views/modules/maps/sidesbar/MapTable'
import DevicesListFilters from '@/views/modules/device/devices-list/DevicesListFilters'
import GeofenceListFilters from '@/views/modules/geofence/geofence-list/GeofenceListFilters'
import flatPickr from 'vue-flatpickr-component'
import useMap from "@/views/modules/maps/uses/useMap";
import mapDevices from "@/views/modules/maps/functions/mapDevices";
import useLiveMapMarkers from "@/views/modules/maps/uses/useLiveMapMarkers";
import mapGeofence from '@/views/modules/maps/functions/mapGeofence'
import mapDrawGeofences from '@/views/modules/maps/mapDrawGeofences'
import Ripple from 'vue-ripple-directive'
import { BButton, BRow, BCol, BModal, BFormGroup, BForm, BFormCheckbox, BCollapse } from 'bootstrap-vue'
import DRoute from '@/views/modules/maps/device-route/DRoute'
import { OrbitSpinner } from 'epic-spinners'
import deviceRoute from '@/views/modules/maps/device-route/deviceRoute'
import L from 'leaflet'
import Marker from '@/map/marker'
import 'leaflet-polylinedecorator'
import 'leaflet-geometryutil'
import store from '@/store'
import { eventBus } from '@/main'
import 'leaflet-routing-machine'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import 'leaflet-routing-machine/src/localization'
import axios from '@/libs/axios'

export default {
components: {
  LMap,
  LTileLayer,
  LMarker,
  BCollapse,
  LPopup,
  LTooltip,
  MapTable,
  BButton, 
  BRow, 
  BCol, 
  BModal,
  DevicesListFilters, 
  GeofenceListFilters,
  flatPickr,
  BFormGroup, 
  BFormCheckbox, 
  DRoute,
  BForm, 
  OrbitSpinner
},
directives: {
  'b-tooltip': VBTooltip,
  'b-toggle': VBToggle,
  Ripple,
},
setup(props, context) {

  let storeDirection = store.state.auth.userData.settings.lang === 'ar' ? 'rtl' : 'ltr'

  const resetDirection=()=>{
    document.getElementsByTagName('html')[0].dir = storeDirection;
  }

  document.getElementsByTagName('html')[0].dir = "ltr"

  const isDevicesTableSideBarActive = ref(false)
  const isGeofenceTableSideBarActive = ref(false)

  const selected_device = ref(null)
  const selected_geofence = ref(null)

  const tracked_devices = ref([])
  const tracked_lines = ref([])

  const allMarkersVisibility = ref(true)
  const markerLabels = ref(true)

  const { map, url, zoom, center, mapRef, init_layers } = useMap()

  const { 
    devices,
    devicesMeta, 
    fetchDevices, 
    d_requestStatus, 
    devicesTableColumns, 
    perPage, 
    r_perPage,
    perPageOptions, 
    currentPage, 
    filter, 
    searchQuery, 
    totalDevices, 
    refDeviceListTable,
    contractsOptions,
    contractsOptions_orig, 
    categoriesOptions, 
    groupsOptions, 
    typesOptions, 
    ownersOptions,
    contractsFilter, 
    groupFilter, 
    typeFilter, 
    categoriesFilter, 
    ownersFilter 
  } = mapDevices()

  const { 
    fetchGeofence, 
    geofences,
    geofenceTableColumns, 
    g_requestStatus, 
    refGeofenceListTable,
    gContractsOptions, 
    gCategoriesOptions, 
    gGroupsOptions,
    gTypesOptions,
    gOwnersOptions,
    gContractsFilter, 
    gGroupFilter, 
    gTypeFilter, 
    gCategoriesFilter, 
    gOwnersFilter,
    totalGeofence,
    geofenceMeta, 
    gSearchQuery, 
    gFilter, 
    gPerPage, 
    gCurrentPage, 
    gDevicesOptions, 
    gDeviceFilter 
  } = mapGeofence()

  const { drawArea, removeAllGeos, geofenceVisibility, allGeofencesDraw } = mapDrawGeofences(map)

  const { init_marker, markersCluster, markersGroupLayer, markers } = useLiveMapMarkers()
  const { update_device } = Marker()

  fetchDevices()
  fetchGeofence()

  let iids = []

  watch(devices, () => {
    
    if(Array.isArray(devices.value)  && devices.value.length > 0 ){
      
      markersCluster.clearLayers()

      iids = []

      devices.value.map(device => {

        if(device.latitude == 0 && device.longitude == 0){
          return;
        }

        iids.push(device.id)
        init_marker(device)

      })

      map.value.addLayer(markersCluster)
      map.value.fitBounds(markersCluster.getBounds());

      if (routingControl.value){
        makeReport.value = false
        map.value.removeControl(routingControl.value)
      } 
      
    }
      
  })

  watch(geofences,() => {
    removeAllGeos()
    geofences.value.map(g => drawArea(g))
  })

  watch(selected_device,() => {
    if (selected_device.value !== null) {
      try {
        map.value.setView(markers.value[selected_device.value].getLatLng(), 16);
      }
      catch (e) {
        console.log("does not have point")
      }
    }
  })

  watch(selected_geofence,(n, o) => {
    if (n !== null) {
      allGeofencesDraw.value[n].setStyle({color: 'red'})
      map.value.fitBounds(allGeofencesDraw.value[n].getBounds())
    }
    if (o !== null) allGeofencesDraw.value[o].setStyle({color: 'black'})
  })

  watch(tracked_devices,(new_value, old_value) => {

    for (const i in new_value) {

      if (!(new_value[i] in old_value)) {
        const line = new L.Polyline([], lineOptions)
        trackedLinesLayer.addLayer(line)
        tracked_lines.value[new_value[0]] = line
      }
    }

    for (const i in old_value) {
      if (!(old_value[i] in new_value)) {
        tracked_lines.value[old_value[i]] = undefined
      }
    }

  })

  eventBus.$on("updateMap", function (data) {
   update_device(markers.value[data.device],  devices.value.find((i)=>data.device==i.id), data)
  })

  const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  let stopped = false

  async function poll() {

    while (!stopped)
    {
      if(iids.length < 1) {
        // wait a second
        await sleep(1000)
        continue
      }

      let ids_str = iids.join(",")

      try
      {
        let response = await axios.get(`/maps/update_map?ids=${ids_str}`)
        console.log(response.data)

        console.log("devices", devices.value)
        for (let i in response.data) {
          if(!Array.isArray(response.data[i])) {

            update_device(
                markers.value[response.data[i].device_id],
                devices.value.find((ii) => response.data[i].device_id == ii.id),
                response.data[i]
            )
          }
        }
      }
      catch (e) {
        console.error(e)
      }

      await sleep(5000)
    }
  }


  const toggleGeofence = () => {
    if (geofenceVisibility.value){
      removeAllGeos()
      geofenceVisibility.value = false
    }

    else {
      geofences.value.map(g => drawArea(g))
      geofenceVisibility.value = true
    }
  }

  const toggleMarkersVisibility = () => {
    if (allMarkersVisibility.value) {
      markersCluster.clearLayers()
      allMarkersVisibility.value = !allMarkersVisibility.value
    }else {
      devices.value.map(device => init_marker(device))
      map.value.addLayer(markersCluster)
      allMarkersVisibility.value = !allMarkersVisibility.value
    }
  }

  const toggleMarkersLabel = () => {
    markerLabels.value = !markerLabels.value
    markersCluster.clearLayers()
    devices.value.map(device => init_marker(device))
    map.value.addLayer(markersCluster)
  }

  const {lineOptions, drawRoute } = deviceRoute()

  const fetchedPoints = (points, areas) => {
    removeAllGeos()
    geofences.value.map(g => drawArea(g, areas))
    drawRoute(points, map)
  }

  const routePoints = L.layerGroup()
  const trackedLinesLayer = L.layerGroup()

  const clearRoute = () => {
    routePoints.clearLayers()
  }

  const makeReport = ref(false)

  watch(makeReport, () => {
    if (routingControl.value) map.value.removeControl(routingControl.value)
  })

  watch(() => store.state.ws.instance, () => {
    if (store.state.ws.instance) {
      store.state.ws.instance.send("send map updates")
      document.addEventListener('visibilitychange', function (event) {
        if (document.hidden) store.state.ws.instance.send("stop send map updates")
        else store.state.ws.instance.send("send map updates")
      })
    }
  })

/////////////  filter   contracts  by owners  //////
const refliterContractByWoners=(owners)=>{          
    let result=contractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id))         
    contractsOptions.value=result;
     if(owners.length==0){     contractsOptions.value=contractsOptions_orig.value; }         
  } 



watch([ownersFilter], () => {refliterContractByWoners(ownersFilter.value)})

///////// refilter contracts of geofences /////////
const refliterGeofncesContractByWoners=(owners)=>{
  let result=contractsOptions_orig.value.filter((i)=>owners.includes(i.contractor_id)) 
   gContractsOptions.value=result;       
   if(owners.length==0){ gContractsOptions.value=contractsOptions_orig.value}
}  
watch([gOwnersFilter],()=>{
refliterGeofncesContractByWoners(gOwnersFilter.value)
})  

/////////end refilter contracts of geofences /////////

  const draw_route = (p) => {

    const nearest = L.GeometryUtil.closestLayer(
        mapRef.value.mapObject, markersGroupLayer.getLayers(), p.latlng)

    if (nearest) {
      const pin = require('@/assets/icons/flag_report.png')
      const icon_pin = L.divIcon({
        html: L.Util.template(`<div><img style="width: 25px" src="${pin}" alt=""></div>`),
        iconSize    : [30, 40], })

      routingControl.value = L.Routing.control({
        position: 'bottomright',
        waypoints: [nearest.latlng, p.latlng],
        lineOptions : {
          addWaypoints: false
        },
        draggableWaypoints: false,
        createMarker: function (i, start, n){
          if (i=== (n - 1)) {
            return L.marker (start.latLng, {
              icon:icon_pin,
              draggable: false,
            })
          }
        },
      }).addTo(map.value)
        markersCluster.addLayer(nearest.layer)
        nearest.layer.addTo(map.value)
    }
  }

  const closed_layer = ref(null)
  const routingControl = ref(null)
   
  const manageMapTheme = ()=>{
    if(document.body.classList.contains('dark-layout')){
      document.body.classList.add('dark-map')
    } else { document.body.classList.remove('dark-map')}
  }

  onMounted(() => {

    manageMapTheme()
    poll()  // start map updates

    map.value = mapRef.value.mapObject
    mapRef.value.mapObject.on('click', p => {
      if (makeReport.value) {
        if (routingControl.value) map.value.removeControl(routingControl.value)
        draw_route(p)
      }
    })

    init_layers()
    map.value.on('baselayerchange', function (e) {

        if(e.layer._url.includes('ArcGIS') || e.layer._url.includes('lyrs=s') ){
          document.body.classList.remove('dark-map')
        }else{
          manageMapTheme()
        }
        
      });
  })

  onUnmounted(() => {
    stopped = true  // stop polling
    if (store.state.ws.instance) {
      store.state.ws.instance.send("stop send map updates")
    }
  })

  const sendRequest = v => {
    d_requestStatus.value = v
  }

  return {

    isDevicesTableSideBarActive,
    isGeofenceTableSideBarActive,

    device_table_data: computed(() => devices.value),
    geofence_table_data: computed(() => geofences.value),

    d_requestStatus, 
    tracked_devices,
    sendRequest, 
    fetchedPoints,
    clearRoute,

    makeReport,
    closed_layer,

    devicesTableColumns,
    refDeviceListTable,
    perPage, 
    r_perPage,
    perPageOptions,
    currentPage,
    filter,
    searchQuery,
    totalDevices,

    contractsOptions, 
    categoriesOptions,
    groupsOptions, 
    typesOptions, 
    ownersOptions,

    contractsFilter, 
    groupFilter,
    typeFilter, 
    categoriesFilter, 
    ownersFilter,

    gTypesOptions,
    gOwnersOptions,
    gContractsFilter, 
    gGroupFilter, 
    gTypeFilter, 
    gCategoriesFilter, 
    gOwnersFilter,
    totalGeofence, 
    gSearchQuery, 
    gFilter, 
    gPerPage, 
    gCurrentPage, 
    gDevicesOptions, 
    gDeviceFilter,
    geofenceTableColumns, 
    g_requestStatus, 
    refGeofenceListTable,
    gContractsOptions, 
    gCategoriesOptions, 
    gGroupsOptions,

    drawArea, 
    removeAllGeos, 
    geofenceVisibility,
    toggleMarkersVisibility,
    allMarkersVisibility,
    toggleMarkersLabel,
    toggleGeofence,
    markerLabels,

    mapRef,
    center,
    zoom,
    url,

    selected_device, 
    selected_geofence,
    drawRoute,
    resetDirection,
    devicesMeta,geofenceMeta
  }
}
}


</script>

<style lang="less">
@import './liveStyles.less';
.leaflet-touch .leaflet-control-layers-toggle {
width: 31px;
height: 33px;
}

.nearest {
background-color: #78bc87;
width: 250px;
height: 90px !important;
z-index: 9999999;
position: absolute;
right: 10px;
bottom: 15px;
border-radius: 5px;
padding: 10px;
color: white;
font-weight: bold;
}


.closed_info {
border-radius: 5px;
background-color: #78bc87;
color: white;
font-weight: bold;
width: 250px;
height: 45px !important;
z-index: 9999999;
position: absolute;
bottom: 110px;
right: 10px;
}

.leaflet-routing-container, .leaflet-routing-error {
background-color: #78bc87 !important;
}

.leaflet-routing-icon {
background-color: antiquewhite !important;
}
///here popup style
.leaflet-popup-content-wrapper{
background-color: white !important;;
color: black;
}

.custom-popup {
color:  #5b5959 !important;
font-weight: bold;
font-family: "Cairo", sans-serif !important;

}
.leaflet-popup-content {
margin: 0px !important;
min-width: 301px !important;
box-sizing: border-box;
}
.leaflet-popup-button {
margin-right: 5px;
margin-left: 5px;
margin-top: 10px;
margin-bottom: 10px;
padding: 4px;
color: #fff;
background-color: #78bc87;
border: none;
}
.leaflet-popup-button:hover {
color: #fff;
background-color: rgb(54, 129, 70);
}
.custom-popup >.header {
font-size: x-large;
font-weight: bold;
background-color: #78bc87;


color: white;
}

.contract table{
width: 100% !important;
}
.custom-popup-table {
width: 100%;
}
.m-label {
// width: max-content;
background-color: aliceblue;
padding: 6px !important;
border: 1px solid;
}
*{
box-sizing: border-box !important;
}





</style>


